import STRINGS from "../../constants/constants";

import CancelButton from "./CancelButton";
import SaveButton from "./SaveButton";

export default function ActionButtons({
  disableSave,
  handleOnClickSaveButton,
  disableCancel,
  handleOnClickCancelBtn,
}) {
  return (
    <div className="flex w-1/2 flex-row justify-end gap-2 px-2 py-4">
      <CancelButton className="w-1/2" disabled={disableCancel} onClick={handleOnClickCancelBtn} />
      <SaveButton
        className="w-1/2"
        disabled={disableSave}
        onClick={handleOnClickSaveButton}
        label={STRINGS.BUTTON_LABELS.SAVE}
      />
    </div>
  );
}
